import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcErrorFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.07 4.258c.875-1.456 2.986-1.456 3.86 0l7.85 13.085c.9 1.5-.18 3.407-1.929 3.408H4.15c-1.749 0-2.829-1.908-1.93-3.408zM12 15.751a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-7.5a.75.75 0 0 0-.75.75v5a.75.75 0 0 0 1.5 0V9a.75.75 0 0 0-.75-.75",
    clipRule: "evenodd"
  }));
}
var IcErrorFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcErrorFill));

export { IcErrorFill as I };
